export enum OrderRules {
  Ascending = "ASC",
  Descending = "DESC",
}
